import React from 'react';
import { useSelector } from 'react-redux';
import ButtonAction from '../../../../../../../components/buttons/ButtonAction';
import { ATTENDANCE_SUBVIEW_MODEL } from '../../../Model/Model';
import { permissionObj } from '../../../../../../../Helpers/permission';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Toggle between the active payroll period ("active") and past periods
 * ("history"). Each button is shown only when the user holds its read permission.
 *
 * @param {string} subView - Currently selected sub-view key.
 * @param {Function} changeSubView - Setter for the selected sub-view.
 */
const PayrollSubViewOptions = ({ subView, changeSubView }) => {
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);

    const canReadActive = DEV || permission?.includes(permissionObj?.WEB_PAYROLL_ACTIVE_READ);
    const canReadHistory = DEV || permission?.includes(permissionObj?.WEB_PAYROLL_HISTORY_READ);

    return (
        <div className='d-flex gap-3'>
            {canReadActive && (
                <ButtonAction
                    id='btn_psvo_active'
                    name='active'
                    className={
                        subView === ATTENDANCE_SUBVIEW_MODEL.PAYROLL.ACTIVE
                            ? 'btn-outlined-secondary-600-100'
                            : 'btn-outlined-secondary-600-00'
                    }
                    disabled={false}
                    splitName={false}
                    onClick={() => changeSubView(ATTENDANCE_SUBVIEW_MODEL.PAYROLL.ACTIVE)}
                />
            )}

            {canReadHistory && (
                <ButtonAction
                    id='btn_psvo_history'
                    name='history'
                    className={
                        subView === ATTENDANCE_SUBVIEW_MODEL.PAYROLL.HISTORY
                            ? 'btn-outlined-secondary-600-100'
                            : 'btn-outlined-secondary-600-00'
                    }
                    disabled={false}
                    splitName={false}
                    onClick={() => changeSubView(ATTENDANCE_SUBVIEW_MODEL.PAYROLL.HISTORY)}
                />
            )}
        </div>
    );
};

export default PayrollSubViewOptions;
